import { React, useState, useEffect } from "react";
import { Modal } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import { URL } from "../../../Helpers/Accesos";

const camposIniciales = { nombre: "", descripcion: "" };

const EditarPresentacionModal = ({ open, onClose, presentacion }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [form, setForm] = useState(camposIniciales);

    useEffect(() => {
        if (open && presentacion) {
            setForm({
                nombre: presentacion.nombre || "",
                descripcion: presentacion.descripcion || "",
            });
        }
    }, [open, presentacion]);

    const onChange = ({ target }) => {
        setForm((prev) => ({ ...prev, [target.name]: target.value }));
    };

    const validar = () => {
        if (!form.nombre.trim()) {
            Swal.fire({
                title: "PRESENTACIONES",
                text: "El nombre es requerido",
                icon: "warning",
                customClass: { container: "mi-superpoop" },
            });
            return false;
        }
        return true;
    };

    const handleGuardar = () => {
        if (!validar()) return;
        setLoader({ ...loader, mostrar: true });

        const body = {
            presentacionId: presentacion.presentacionId,
            nombre: form.nombre.trim(),
            descripcion: form.descripcion.trim(),
            usuario: 0,
        };

        const token = localStorage.getItem("HumayaDigital-Token");
        fetch(`${URL}Presentacion/Actualizar`, {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        })
            .then(async (result) => {
                const data = await result.json();
                if (result.ok) {
                    setLoader({ ...loader, mostrar: false });
                    await Swal.fire({
                        title: "PRESENTACIONES",
                        text: "Presentación actualizada con éxito",
                        icon: "success",
                        customClass: { container: "mi-superpoop" },
                    });
                    handleCancelar();
                } else {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("PRESENTACIONES", JSON.stringify(data), "error");
                }
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("PRESENTACIONES", JSON.stringify(error), "error");
            });
    };

    const handleCancelar = () => {
        setForm(camposIniciales);
        onClose();
    };

    return (
        <Modal open={open} onClose={handleCancelar}>
            <div className="editar-presentacion-modal-formulario">
                <div className="editar-presentacion-modal-plantilla">
                    <div className="plantilla-screen-filtro-container" id="editar-presentacion-modal">
                        <PlantillaScreen
                            titulo="EDITAR PRESENTACIÓN"
                            className_main={1}
                            className="plantilla-screen-filtro-container-modal"
                        >
                            <div className="cerrar-modal-button" onClick={handleCancelar}>X</div>
                            <LoaderScreen loader={loader} />
                            <div className="editar-presentacion-modal-content">
                                <div className="editar-presentacion-modal-content-container scroll-4">
                                    <div className="pres-form-group">
                                        <label>Nombre *</label>
                                        <input
                                            type="text"
                                            name="nombre"
                                            value={form.nombre}
                                            onChange={onChange}
                                            placeholder="Nombre de la presentación"
                                            maxLength={200}
                                        />
                                    </div>
                                    <div className="pres-form-group">
                                        <label>Descripción</label>
                                        <textarea
                                            name="descripcion"
                                            value={form.descripcion}
                                            onChange={onChange}
                                            placeholder="Descripción de la presentación"
                                            rows={4}
                                        />
                                    </div>
                                </div>
                                <div className="editar-presentacion-modal-buttons">
                                    <button
                                        className="editar-presentacion-modal-button-cancelar"
                                        onClick={handleCancelar}
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        className="editar-presentacion-modal-button-guardar"
                                        onClick={handleGuardar}
                                        disabled={loader.mostrar}
                                    >
                                        Guardar
                                    </button>
                                </div>
                            </div>
                        </PlantillaScreen>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EditarPresentacionModal;
